import { cUtil } from "../../functions/util";

export class cContact {

  div_message               = document.createElement('div');

  div_companyName           = document.createElement('div');
  label_companyName         = document.createElement('label');
  input_companyName         = document.createElement('input');
  err_companyName           = document.createElement('div');

  div_businessName          = document.createElement('div');
  label_businessName        = document.createElement('label');
  input_businessName        = document.createElement('input');
  err_businessName          = document.createElement('div');

  div_contactFirstName      = document.createElement('div');
  label_contactFirstName    = document.createElement('label');
  input_contactFirstName    = document.createElement('input');
  err_contactFirstName      = document.createElement('div');

  div_contactLastName       = document.createElement('div');
  label_contactLastName     = document.createElement('label');
  input_contactLastName     = document.createElement('input');
  err_contactLastName       = document.createElement('div');

  div_role                  = document.createElement('div');
  label_role                = document.createElement('label');
  select_role               = document.createElement('select');
  option_fn0                = document.createElement('option');
  option_fn1                = document.createElement('option');
  option_fn2                = document.createElement('option');
  option_fn3                = document.createElement('option');
  option_fn4                = document.createElement('option');
  option_fn5                = document.createElement('option');
  option_fn6                = document.createElement('option');
  err_role                  = document.createElement('div');

  div_businessType          = document.createElement('div');
  label_businessType        = document.createElement('label');
  select_businessType       = document.createElement('select');
  option_bt0                = document.createElement('option');
  option_bt1                = document.createElement('option');
  option_bt2                = document.createElement('option');
  option_bt3                = document.createElement('option');
  option_bt4                = document.createElement('option');
  option_bt5                = document.createElement('option');
  err_businessType          = document.createElement('div');

  div_businessTypeOther     = document.createElement('div');
  label_businessTypeOther   = document.createElement('label');
  input_businessTypeOther   = document.createElement('input');
  err_businessTypeOther     = document.createElement('div');

  div_street                = document.createElement('div');
  label_street              = document.createElement('label');
  input_street              = document.createElement('input');
  err_street                = document.createElement('div');

  div_postcode              = document.createElement('div');
  label_postcode            = document.createElement('label');
  input_postcode            = document.createElement('input');
  err_postcode              = document.createElement('div');

  div_city                  = document.createElement('div');
  label_city                = document.createElement('label');
  input_city                = document.createElement('input');
  err_city                  = document.createElement('div');

  div_phone                 = document.createElement('div');
  label_phone               = document.createElement('label');
  input_phone               = document.createElement('input');
  err_phone                 = document.createElement('div');

  div_email                 = document.createElement('div');
  label_email               = document.createElement('label');
  input_email               = document.createElement('input');
  err_email                 = document.createElement('div');

  div_uid                   = document.createElement('div');
  label_uid                 = document.createElement('label');
  input_uid                 = document.createElement('input');
  err_uid                   = document.createElement('div');

  div_revenue               = document.createElement('div');
  label_revenue             = document.createElement('label');
  select_revenue            = document.createElement('select');
  option_rv0                = document.createElement('option');
  option_rv1                = document.createElement('option');
  option_rv2                = document.createElement('option');
  option_rv3                = document.createElement('option');
  option_rv4                = document.createElement('option');
  err_revenue               = document.createElement('div');

  div_source                = document.createElement('div');
  label_source              = document.createElement('label');
  select_source             = document.createElement('select');
  option_sc0                = document.createElement('option');
  option_sc1                = document.createElement('option');
  option_sc2                = document.createElement('option');
  option_sc3                = document.createElement('option');
  option_sc4                = document.createElement('option');
  option_sc5                = document.createElement('option');
  option_sc6                = document.createElement('option');
  option_sc7                = document.createElement('option');
  err_source                = document.createElement('div');

  div_sourceOther           = document.createElement('div');
  label_sourceOther         = document.createElement('label');
  input_sourceOther         = document.createElement('input');
  err_sourceOther           = document.createElement('div');

  div_remarks               = document.createElement('div');
  label_remarks             = document.createElement('label');
  textarea_remarks          = document.createElement('textarea');
  err_remarks               = document.createElement('div');

  div_confirm               = document.createElement('div');
  div_confirmCommercial     = document.createElement('div');
  input_confirmCommercial   = document.createElement('input');
  label_confirmCommercial   = document.createElement('label');
  div_confirmConditions     = document.createElement('div');
  input_confirmConditions   = document.createElement('input');
  label_confirmConditions   = document.createElement('label');
  div_confirmPrivacy        = document.createElement('div');
  input_confirmPrivacy      = document.createElement('input');
  label_confirmPrivacy      = document.createElement('label');
  a_privacy                 = document.createElement('a');
  err_confirm               = document.createElement('div');

  div_turnstile             = document.createElement('div');
  err_turnstile             = document.createElement('div');
  button_send               = document.createElement('button');

  div_intro                 = document.querySelector('.c-contact-intro')  as HTMLElement | null;
  parent                    = document.querySelector('.c-contact')        as HTMLElement;
  script_json               = document.querySelector('.c-contact script') as HTMLScriptElement;

  input : ContactRequest;

  constructor() {

    this.input = JSON.parse(this.script_json.textContent ?? '{}') as ContactRequest;

    // ---- Structure ----
    this.parent.append(this.div_message);

    this.parent.append(this.div_companyName);
      this.div_companyName.append(this.label_companyName);
      this.div_companyName.append(this.input_companyName);
      this.div_companyName.append(this.err_companyName);

    this.parent.append(this.div_businessName);
      this.div_businessName.append(this.label_businessName);
      this.div_businessName.append(this.input_businessName);
      this.div_businessName.append(this.err_businessName);

    this.parent.append(this.div_contactFirstName);
      this.div_contactFirstName.append(this.label_contactFirstName);
      this.div_contactFirstName.append(this.input_contactFirstName);
      this.div_contactFirstName.append(this.err_contactFirstName);

    this.parent.append(this.div_contactLastName);
      this.div_contactLastName.append(this.label_contactLastName);
      this.div_contactLastName.append(this.input_contactLastName);
      this.div_contactLastName.append(this.err_contactLastName);

    this.parent.append(this.div_role);
      this.div_role.append(this.label_role);
      this.div_role.append(this.select_role);
        this.select_role.append(this.option_fn0);
        this.select_role.append(this.option_fn1);
        this.select_role.append(this.option_fn2);
        this.select_role.append(this.option_fn3);
        this.select_role.append(this.option_fn4);
        this.select_role.append(this.option_fn5);
        this.select_role.append(this.option_fn6);
      this.div_role.append(this.err_role);

    this.parent.append(this.div_businessType);
      this.div_businessType.append(this.label_businessType);
      this.div_businessType.append(this.select_businessType);
        this.select_businessType.append(this.option_bt0);
        this.select_businessType.append(this.option_bt1);
        this.select_businessType.append(this.option_bt2);
        this.select_businessType.append(this.option_bt3);
        this.select_businessType.append(this.option_bt4);
        this.select_businessType.append(this.option_bt5);
      this.div_businessType.append(this.err_businessType);

    this.parent.append(this.div_businessTypeOther);
      this.div_businessTypeOther.append(this.label_businessTypeOther);
      this.div_businessTypeOther.append(this.input_businessTypeOther);
      this.div_businessTypeOther.append(this.err_businessTypeOther);

    this.parent.append(this.div_street);
      this.div_street.append(this.label_street);
      this.div_street.append(this.input_street);
      this.div_street.append(this.err_street);

    this.parent.append(this.div_postcode);
      this.div_postcode.append(this.label_postcode);
      this.div_postcode.append(this.input_postcode);
      this.div_postcode.append(this.err_postcode);

    this.parent.append(this.div_city);
      this.div_city.append(this.label_city);
      this.div_city.append(this.input_city);
      this.div_city.append(this.err_city);

    this.parent.append(this.div_phone);
      this.div_phone.append(this.label_phone);
      this.div_phone.append(this.input_phone);
      this.div_phone.append(this.err_phone);

    this.parent.append(this.div_email);
      this.div_email.append(this.label_email);
      this.div_email.append(this.input_email);
      this.div_email.append(this.err_email);

    this.parent.append(this.div_uid);
      this.div_uid.append(this.label_uid);
      this.div_uid.append(this.input_uid);
      this.div_uid.append(this.err_uid);

    this.parent.append(this.div_revenue);
      this.div_revenue.append(this.label_revenue);
      this.div_revenue.append(this.select_revenue);
        this.select_revenue.append(this.option_rv0);
        this.select_revenue.append(this.option_rv1);
        this.select_revenue.append(this.option_rv2);
        this.select_revenue.append(this.option_rv3);
        this.select_revenue.append(this.option_rv4);
      this.div_revenue.append(this.err_revenue);

    this.parent.append(this.div_source);
      this.div_source.append(this.label_source);
      this.div_source.append(this.select_source);
        this.select_source.append(this.option_sc0);
        this.select_source.append(this.option_sc1);
        this.select_source.append(this.option_sc2);
        this.select_source.append(this.option_sc3);
        this.select_source.append(this.option_sc4);
        this.select_source.append(this.option_sc5);
        this.select_source.append(this.option_sc6);
        this.select_source.append(this.option_sc7);
      this.div_source.append(this.err_source);

    this.parent.append(this.div_sourceOther);
      this.div_sourceOther.append(this.label_sourceOther);
      this.div_sourceOther.append(this.input_sourceOther);
      this.div_sourceOther.append(this.err_sourceOther);

    this.parent.append(this.div_remarks);
      this.div_remarks.append(this.label_remarks);
      this.div_remarks.append(this.textarea_remarks);
      this.div_remarks.append(this.err_remarks);

    this.parent.append(this.div_confirm);
      this.div_confirm.append(this.div_confirmCommercial);
        this.div_confirmCommercial.append(this.input_confirmCommercial);
        this.div_confirmCommercial.append(this.label_confirmCommercial);
      this.div_confirm.append(this.div_confirmConditions);
        this.div_confirmConditions.append(this.input_confirmConditions);
        this.div_confirmConditions.append(this.label_confirmConditions);
      this.div_confirm.append(this.div_confirmPrivacy);
        this.div_confirmPrivacy.append(this.input_confirmPrivacy);
        this.div_confirmPrivacy.append(this.label_confirmPrivacy);
        this.div_confirmPrivacy.append(this.a_privacy);
      this.div_confirm.append(this.err_confirm);

    this.parent.append(this.div_turnstile);
    this.parent.append(this.err_turnstile);
    this.parent.append(this.button_send);

    // ---- Texts ----
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    this.label_companyName      .textContent = __('Firmenname'                            , 'custom');
    this.label_businessName     .textContent = __('Betriebsname (falls abweichend)'       , 'custom');
    this.label_contactFirstName .textContent = __('Ansprechpartner Vorname'               , 'custom');
    this.label_contactLastName  .textContent = __('Ansprechpartner Nachname'              , 'custom');
    this.label_role             .textContent = __('Funktion im Betrieb'                   , 'custom');
    this.label_businessType     .textContent = __('Betriebsart'                           , 'custom');
    this.label_businessTypeOther.textContent = __('Betriebsart (weitere)'                 , 'custom');
    this.label_street           .textContent = __('Strasse und Hausnummer'                , 'custom');
    this.label_postcode         .textContent = __('PLZ'                                   , 'custom');
    this.label_city             .textContent = __('Ort'                                   , 'custom');
    this.label_phone            .textContent = __('Telefon'                               , 'custom');
    this.label_email            .textContent = __('E-Mail'                                , 'custom');
    this.label_uid              .textContent = __('UID-Nummer (optional)'                 , 'custom');
    this.label_revenue          .textContent = __('Geschätzter Jahresumsatz'              , 'custom');
    this.label_source           .textContent = __('Wie sind Sie auf uns aufmerksam geworden?', 'custom');
    this.label_sourceOther      .textContent = __('Wie sind Sie auf uns aufmerksam geworden? (weitere)', 'custom');
    this.label_remarks          .textContent = __('Bemerkungen (optional)'                , 'custom');

    this.option_fn0.textContent = '— ' + __('bitte wählen', 'custom') + ' —';
    this.option_fn1.textContent = __('Inhaber'         , 'custom');
    this.option_fn2.textContent = __('Geschäftsleiter' , 'custom');
    this.option_fn3.textContent = __('Küchenchef'      , 'custom');
    this.option_fn4.textContent = __('Sous-Chef'       , 'custom');
    this.option_fn5.textContent = __('Koch'            , 'custom');
    this.option_fn6.textContent = __('Purchasemanager' , 'custom');

    this.option_bt0.textContent = '— ' + __('bitte wählen', 'custom') + ' —';
    this.option_bt1.textContent = __('Restaurant'  , 'custom');
    this.option_bt2.textContent = __('Hotel'       , 'custom');
    this.option_bt3.textContent = __('Kantine'     , 'custom');
    this.option_bt4.textContent = __('Institution' , 'custom');
    this.option_bt5.textContent = __('Weitere'     , 'custom');

    this.option_rv0.textContent = '— ' + __('bitte wählen', 'custom') + ' —';
    this.option_rv1.textContent = __('CHF 10 000–25 000' , 'custom');
    this.option_rv2.textContent = __('CHF 25 000–50 000' , 'custom');
    this.option_rv3.textContent = __('CHF 50 000–100 000', 'custom');
    this.option_rv4.textContent = __('über CHF 100 000'  , 'custom');

    this.option_sc0.textContent = '— ' + __('bitte wählen', 'custom') + ' —';
    this.option_sc1.textContent = __('Empfehlung (Kollege, Lieferant, Bekannter)', 'custom');
    this.option_sc2.textContent = __('Suchmaschine (Google und weitere)'         , 'custom');
    this.option_sc3.textContent = __('Social Media'                              , 'custom');
    this.option_sc4.textContent = __('bestehende Geschäftsbeziehung'             , 'custom');
    this.option_sc5.textContent = __('Messe oder Veranstaltung'                  , 'custom');
    this.option_sc6.textContent = __('Aussendienst der Metzgerei Grauwiler'      , 'custom');
    this.option_sc7.textContent = __('Weitere'                                   , 'custom');

    this.label_confirmCommercial.textContent = __('Ich bestätige, dass ich diese Anfrage für einen gewerblichen Betrieb stelle.', 'custom');
    this.label_confirmConditions.textContent = __('Ich nehme die Voraussetzungen für eine Belieferung zur Kenntnis (Standort Nordwestschweiz, Jahresumsatz ab CHF 10 000, Mindestabladewert CHF 500).', 'custom');
    this.label_confirmPrivacy   .textContent = __('Ich habe die Datenschutzerklärung gelesen und bin mit der Bearbeitung meiner Angaben einverstanden.', 'custom');
    this.a_privacy              .textContent = __('Datenschutzerklärung anzeigen', 'custom');
    this.button_send            .textContent = __('Anfrage senden', 'custom');

    // ---- Label Ids ----
    cUtil.labelIds(this.label_companyName      , this.input_companyName);
    cUtil.labelIds(this.label_businessName     , this.input_businessName);
    cUtil.labelIds(this.label_contactFirstName , this.input_contactFirstName);
    cUtil.labelIds(this.label_contactLastName  , this.input_contactLastName);
    cUtil.labelIds(this.label_role             , this.select_role);
    cUtil.labelIds(this.label_businessType     , this.select_businessType);
    cUtil.labelIds(this.label_businessTypeOther, this.input_businessTypeOther);
    cUtil.labelIds(this.label_street           , this.input_street);
    cUtil.labelIds(this.label_postcode         , this.input_postcode);
    cUtil.labelIds(this.label_city             , this.input_city);
    cUtil.labelIds(this.label_phone            , this.input_phone);
    cUtil.labelIds(this.label_email            , this.input_email);
    cUtil.labelIds(this.label_uid              , this.input_uid);
    cUtil.labelIds(this.label_revenue          , this.select_revenue);
    cUtil.labelIds(this.label_source           , this.select_source);
    cUtil.labelIds(this.label_sourceOther      , this.input_sourceOther);
    cUtil.labelIds(this.label_remarks          , this.textarea_remarks);
    cUtil.labelIds(this.label_confirmCommercial, this.input_confirmCommercial);
    cUtil.labelIds(this.label_confirmConditions, this.input_confirmConditions);
    cUtil.labelIds(this.label_confirmPrivacy   , this.input_confirmPrivacy);

    // ---- Other ----
    this.input_companyName       .type = 'text';
    this.input_businessName      .type = 'text';
    this.input_contactFirstName  .type = 'text';
    this.input_contactLastName   .type = 'text';
    this.input_businessTypeOther .type = 'text';
    this.input_street            .type = 'text';
    this.input_postcode          .type = 'text';
    this.input_city              .type = 'text';
    this.input_phone             .type = 'tel';
    this.input_email             .type = 'email';
    this.input_uid               .type = 'text';
    this.input_sourceOther       .type = 'text';

    this.input_companyName       .maxLength = 255;
    this.input_businessName      .maxLength = 255;
    this.input_contactFirstName  .maxLength = 255;
    this.input_contactLastName   .maxLength = 255;
    this.input_businessTypeOther .maxLength = 255;
    this.input_street            .maxLength = 255;
    this.input_postcode          .maxLength = 255;
    this.input_city              .maxLength = 255;
    this.input_phone             .maxLength = 255;
    this.input_email             .maxLength = 255;
    this.input_uid               .maxLength = 255;
    this.input_sourceOther       .maxLength = 255;
    this.textarea_remarks        .maxLength = 2000;
    this.textarea_remarks        .rows      = 5;

    this.input_companyName     .autocomplete = 'organization';
    this.input_contactFirstName.autocomplete = 'given-name';
    this.input_contactLastName .autocomplete = 'family-name';
    this.input_street          .autocomplete = 'street-address';
    this.input_postcode        .autocomplete = 'postal-code';
    this.input_city            .autocomplete = 'address-level2';
    this.input_phone           .autocomplete = 'tel';
    this.input_email           .autocomplete = 'email';

    this.input_confirmCommercial.type = 'checkbox';
    this.input_confirmConditions.type = 'checkbox';
    this.input_confirmPrivacy   .type = 'checkbox';

    this.option_fn0.value = 'none';
    this.option_fn1.value = 'Inhaber';
    this.option_fn2.value = 'Geschäftsleiter';
    this.option_fn3.value = 'Küchenchef';
    this.option_fn4.value = 'Sous-Chef';
    this.option_fn5.value = 'Koch';
    this.option_fn6.value = 'Purchasemanager';

    this.option_bt0.value = '';
    this.option_bt1.value = 'Restaurant';
    this.option_bt2.value = 'Hotel';
    this.option_bt3.value = 'Kantine';
    this.option_bt4.value = 'Institution';
    this.option_bt5.value = 'weitere';

    this.option_rv0.value = '';
    this.option_rv1.value = '10-25';
    this.option_rv2.value = '25-50';
    this.option_rv3.value = '50-100';
    this.option_rv4.value = '100+';

    this.option_sc0.value = '';
    this.option_sc1.value = 'Empfehlung';
    this.option_sc2.value = 'suchmaschine';
    this.option_sc3.value = 'Social Media';
    this.option_sc4.value = 'Bestehende Beziehung';
    this.option_sc5.value = 'Messe';
    this.option_sc6.value = 'Aussendienst';
    this.option_sc7.value = 'weitere';

    this.a_privacy.href   = cUtil.url('/datenschutzerklaerung/');
    this.a_privacy.target = '_blank';
    this.a_privacy.rel    = 'noopener';

    this.button_send.type = 'button';
    this.button_send.classList.add('c-button-simple');

    this.div_companyName      .classList.add('c-field');
    this.div_businessName     .classList.add('c-field');
    this.div_contactFirstName .classList.add('c-field');
    this.div_contactLastName  .classList.add('c-field');
    this.div_role             .classList.add('c-field');
    this.div_businessType     .classList.add('c-field');
    this.div_businessTypeOther.classList.add('c-field');
    this.div_street           .classList.add('c-field');
    this.div_postcode         .classList.add('c-field');
    this.div_city             .classList.add('c-field');
    this.div_phone            .classList.add('c-field');
    this.div_email            .classList.add('c-field');
    this.div_uid              .classList.add('c-field');
    this.div_revenue          .classList.add('c-field');
    this.div_source           .classList.add('c-field');
    this.div_sourceOther      .classList.add('c-field');
    this.div_remarks          .classList.add('c-field');
    this.div_confirm          .classList.add('c-confirm');
    this.div_turnstile        .classList.add('c-turnstile');

    this.div_businessTypeOther.classList.add('c-hidden');
    this.div_sourceOther      .classList.add('c-hidden');

    // ---- init ----
    this.option_fn0.selected = true;
    this.option_bt0.selected = true;
    this.option_rv0.selected = true;
    this.option_sc0.selected = true;

    this.renderTurnstile();

    // ---- Events ----
    this.input_companyName       .addEventListener('blur'  , () => { this.validateCompanyName();       });
    this.input_contactFirstName  .addEventListener('blur'  , () => { this.validateContactFirstName();  });
    this.input_contactLastName   .addEventListener('blur'  , () => { this.validateContactLastName();   });
    this.select_role             .addEventListener('change', () => { this.validateRole();              });
    this.input_street            .addEventListener('blur'  , () => { this.validateStreet();            });
    this.input_postcode          .addEventListener('blur'  , () => { this.validatePostcode();          });
    this.input_city              .addEventListener('blur'  , () => { this.validateCity();              });
    this.input_phone             .addEventListener('blur'  , () => { this.validatePhone();             });
    this.input_email             .addEventListener('blur'  , () => { this.validateEmail();             });
    this.input_businessTypeOther .addEventListener('blur'  , () => { this.validateBusinessTypeOther(); });
    this.input_sourceOther       .addEventListener('blur'  , () => { this.validateSourceOther();       });

    this.select_businessType.addEventListener('change', () => {
      this.div_businessTypeOther.classList.toggle('c-hidden', this.select_businessType.value !== 'weitere');
      this.validateBusinessType();
    });

    this.select_revenue.addEventListener('change', () => {
      this.validateRevenue();
    });

    this.select_source.addEventListener('change', () => {
      this.div_sourceOther.classList.toggle('c-hidden', this.select_source.value !== 'weitere');
      this.validateSource();
    });

    this.input_confirmCommercial.addEventListener('change', () => { this.validateConfirm(); });
    this.input_confirmConditions.addEventListener('change', () => { this.validateConfirm(); });
    this.input_confirmPrivacy   .addEventListener('change', () => { this.validateConfirm(); });

    this.button_send.addEventListener('click', async () => {
      const { __, _x, _n, sprintf } = wp.i18n as i18n;

      const v1  = this.validateCompanyName();
      const v2  = this.validateContactFirstName();
      const v3  = this.validateContactLastName();
      const v4  = this.validateRole();
      const v5  = this.validateBusinessType();
      const v6  = this.validateBusinessTypeOther();
      const v7  = this.validateStreet();
      const v8  = this.validatePostcode();
      const v9  = this.validateCity();
      const v10 = this.validatePhone();
      const v11 = this.validateEmail();
      const v12 = this.validateRevenue();
      const v13 = this.validateSource();
      const v14 = this.validateSourceOther();
      const v15 = this.validateConfirm();
      const v16 = this.validateTurnstile();

      const isValid =
        v1 && v2 && v3 && v4 && v5 && v6 && v7 && v8 &&
        v9 && v10 && v11 && v12 && v13 && v14 && v15 && v16;

      if (!isValid) {
        this.message(__('Bitte prüfen Sie die markierten Felder.', 'custom'), false);
        return;
      }

      this.input.companyName       = this.input_companyName.value.trim();
      this.input.businessName      = this.input_businessName.value.trim();
      this.input.contactFirstName  = this.input_contactFirstName.value.trim();
      this.input.contactLastName   = this.input_contactLastName.value.trim();
      this.input.role              = this.select_role.value;
      this.input.businessType      = this.select_businessType.value;
      this.input.businessTypeOther = this.select_businessType.value === 'weitere' ? this.input_businessTypeOther.value.trim() : '';
      this.input.street            = this.input_street.value.trim();
      this.input.postcode          = this.input_postcode.value.trim();
      this.input.city              = this.input_city.value.trim();
      this.input.phone             = this.input_phone.value.trim();
      this.input.email             = this.input_email.value.trim();
      this.input.uid               = this.input_uid.value.trim();
      this.input.revenue           = this.select_revenue.value;
      this.input.source            = this.select_source.value;
      this.input.sourceOther       = this.select_source.value === 'weitere' ? this.input_sourceOther.value.trim() : '';
      this.input.remarks           = this.textarea_remarks.value.trim();
      this.input.confirmCommercial = this.input_confirmCommercial.checked;
      this.input.confirmConditions = this.input_confirmConditions.checked;
      this.input.confirmPrivacy    = this.input_confirmPrivacy.checked;

      this.button_send.disabled = true;

      const data     = JSON.stringify(this.input);
      const response = await this.fetch(data, 'c_contact');

      if (!response.ok) {
        this.button_send.disabled = false;
        this.resetTurnstile();
        this.message(response.message, false);
        return;
      }

      this.div_intro?.classList.add('c-hidden');
      this.parent.replaceChildren(this.div_message);
      this.message(response.message, true);
    })
  }

  message(text: string, isSuccess: boolean): void {
    this.div_message.textContent = text;
    this.div_message.classList.toggle('c-success', isSuccess);
    this.div_message.classList.toggle('c-alert'  , !isSuccess);
  }

  renderTurnstile(): void {
    if (this.input.turnstileSiteKey === '') return;

    const render = () => {
      turnstile.render(this.div_turnstile, {
        sitekey  : this.input.turnstileSiteKey,
        language : cUtil.locale(),
        callback : (token: string) => {
          this.input.turnstileToken = token;
          this.validateTurnstile();
        },
        'expired-callback': () => { this.input.turnstileToken = ''; },
        'error-callback'  : () => { this.input.turnstileToken = ''; },
      });
    };

    // The Cloudflare script is loaded with render=explicit, it may not be there yet.
    if (typeof turnstile !== 'undefined') render();
    else window.onloadTurnstileCallback = render;
  }

  resetTurnstile(): void {
    this.input.turnstileToken = '';
    if (typeof turnstile === 'undefined') return;
    turnstile.reset(this.div_turnstile);
  }

  showError(elm: HTMLElement, err: HTMLElement, message: string): boolean {
    if (message !== '') {
      err.textContent = message;
      err.classList.add('c--error');
      elm.classList.add('c--error-marker');
      return false;
    }
    err.textContent = '';
    err.classList.remove('c--error');
    elm.classList.remove('c--error-marker');
    return true;
  }

  required(elm: HTMLInputElement | HTMLSelectElement, err: HTMLElement): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    const message = elm.value.trim() === '' ? __('Bitte füllen Sie das Feld aus.', 'custom') : '';
    return this.showError(elm, err, message);
  }

  validateCompanyName     (): boolean { return this.required(this.input_companyName     , this.err_companyName     ); }
  validateContactFirstName(): boolean { return this.required(this.input_contactFirstName, this.err_contactFirstName); }
  validateContactLastName (): boolean { return this.required(this.input_contactLastName , this.err_contactLastName ); }
  validateStreet          (): boolean { return this.required(this.input_street          , this.err_street          ); }
  validateCity            (): boolean { return this.required(this.input_city            , this.err_city            ); }
  validateBusinessType    (): boolean { return this.required(this.select_businessType   , this.err_businessType    ); }
  validateRevenue         (): boolean { return this.required(this.select_revenue        , this.err_revenue         ); }
  validateSource          (): boolean { return this.required(this.select_source         , this.err_source          ); }

  // The role select uses the same option values as the account details form, where the
  // placeholder is 'none' rather than an empty string.
  validateRole(): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    const message = this.select_role.value === 'none' ? __('Bitte füllen Sie das Feld aus.', 'custom') : '';
    return this.showError(this.select_role, this.err_role, message);
  }

  validateBusinessTypeOther(): boolean {
    if (this.select_businessType.value !== 'weitere') {
      return this.showError(this.input_businessTypeOther, this.err_businessTypeOther, '');
    }
    return this.required(this.input_businessTypeOther, this.err_businessTypeOther);
  }

  validateSourceOther(): boolean {
    if (this.select_source.value !== 'weitere') {
      return this.showError(this.input_sourceOther, this.err_sourceOther, '');
    }
    return this.required(this.input_sourceOther, this.err_sourceOther);
  }

  validatePostcode(): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    const value    = this.input_postcode.value.trim();
    const isNumber = /^[0-9]{4}$/;

    const message =
      value === ''            ? __('Bitte füllen Sie das Feld aus.', 'custom') :
      !isNumber.test(value)   ? __('Bitte geben Sie eine vierstellige PLZ ein.', 'custom') :
      /*else*/ '';

    return this.showError(this.input_postcode, this.err_postcode, message);
  }

  validatePhone(): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    const value   = this.input_phone.value.trim();
    const isPhone = /^[0-9+\/\.\-\s\(\)]{10,}$/;

    const message =
      value === ''          ? __('Bitte füllen Sie das Feld aus.', 'custom') :
      !isPhone.test(value)  ? __('Dies ist keine gültige Telefonnummer.', 'custom') :
      /*else*/ '';

    return this.showError(this.input_phone, this.err_phone, message);
  }

  validateEmail(): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    const value   = this.input_email.value.trim();
    const isEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const message =
      value === ''          ? __('Bitte füllen Sie das Feld aus.', 'custom') :
      !isEmail.test(value)  ? __('Dies ist keine gültige E-Mail-Adresse.', 'custom') :
      /*else*/ '';

    return this.showError(this.input_email, this.err_email, message);
  }

  validateConfirm(): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    const allChecked =
      this.input_confirmCommercial.checked &&
      this.input_confirmConditions.checked &&
      this.input_confirmPrivacy.checked;

    const message = allChecked ? '' : __('Bitte bestätigen Sie alle drei Punkte.', 'custom');
    return this.showError(this.div_confirm, this.err_confirm, message);
  }

  validateTurnstile(): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    const message = this.input.turnstileToken === '' ? __('Bitte bestätigen Sie, dass Sie kein Roboter sind.', 'custom') : '';
    return this.showError(this.div_turnstile, this.err_turnstile, message);
  }

  async fetch(data: string, action: string): Promise<ContactResponse> {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    const  formData = new FormData();
    formData.append('_ajax_nonce', this.input.nonce);
    formData.append('action'     , action);
    formData.append('data'       , data);

    try {
      const response = await fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        body: formData
      });
      const responseData = await response.json() as ContactResponse;
      return responseData;
    }
    catch {
      return {ok: false, message: __('Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.', 'custom')};
    }
  }

}
